/* global Ad */
import Cookies from 'js-cookie';

/**
 * @param $ jQuery objekt
 * @param {Object} loosen oblika
 * * multipleUnitsAllowed ako je true dodajemo opciju "u više smještajnih jedinica"
 * * noDiscounts ako je true uklanjamo popuste
 * * message Toast poruka za ispis
 *
 * @return Boolean Jesu li uklonjeni neki parametri u svrhu "opuštanja" pretrage
 */
export function loosenParametersUnconfigured($, ToastManager, loosen) {
    if (loosen) {
        const {
            multipleUnitsAllowed,
            noDiscounts,
            message,
        } = loosen;

        const selectorClass = 'loosen';
        let cookie = '';

        if (multipleUnitsAllowed === true) {
            $('#SearchPrivateFilterForm_p_dist').prop('checked', true).change();
            cookie = 'loosen-multiple-units';
        }

        if (noDiscounts === true) {
            $('input[name="SearchPrivateFilterForm[dc_t][]"]:checked').prop('checked', false);
            cookie = 'loosen-no-discounts';
        }

        if (!Cookies.get(cookie)) {
            ToastManager.add('info-closable', message, 9999, selectorClass);
        }

        setCookieOnClose($, selectorClass, cookie);

        return true;
    }

    return false;
}

function setCookieOnClose($, selectorClass, cookie) {
    $(`.${selectorClass} .closeToast`).on('click', () => {
        Cookies.set(cookie, true);
    });
}

export default function loosenParametersConfigured(data) {
    return loosenParametersUnconfigured($, Ad.ToastManager, data);
}
